import { ADD_TO_DO, REMOVE_TO_DO } from '../actions'

const initialState = {
  todos: [{ id: 0, text: 'example to do' }],
}

const toDoApp = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_DO:
      const { id, text } = action.payload
      return { ...state, todos: [...state.todos, { id, text }] }
    case REMOVE_TO_DO:
      const removeId = action.payload
      return {
        ...state,
        todos: [...state.todos.filter((todos) => todos.id !== removeId)],
        // add to array
        // results: state.results.concat(newResult)
        // results: [...state.results,newResult]
      }
    default:
      return state
  }
}

export default toDoApp
